import React from 'react';
import InfoPage from '../components/InfoPage';

const EFFECTIVE_DATE = 'August 8, 2026';
const SUPPORT_EMAIL = 'support@kinetocut.com';

export default function TermsAndConditions() {
  return (
    <InfoPage
      eyebrow="Legal"
      title="Terms & Conditions"
      subtitle="The terms that govern your use of KinetoCut."
      icon="§"
      aside={(
        <>
          <span className="card-kicker">Document status</span>
          <h2>Effective {EFFECTIVE_DATE}</h2>
          <p>By creating an account or using the KinetoCut app, you agree to these terms.</p>
          <div className="aside-note"><span>i</span><p>Questions about these terms? Email {SUPPORT_EMAIL}.</p></div>
        </>
      )}
    >
      <section>
        <h2>Acceptance of terms</h2>
        <p>These Terms & Conditions ("Terms") govern your access to and use of KinetoCut, including this website, your account, and the KinetoCut mobile apps (together, the "Service"). By creating an account or using the Service, you agree to these Terms. If you do not agree, do not use the Service.</p>
      </section>
      <section>
        <h2>The service</h2>
        <p>KinetoCut is a video editing app with Easy and Studio editing modes. Edits are stored as project data, and every export creates a new output file rather than modifying your original media.</p>
      </section>
      <section>
        <h2>Accounts</h2>
        <p>You must provide accurate information when creating an account and are responsible for keeping your login credentials confidential. You are responsible for all activity that happens under your account. Tell us right away if you suspect unauthorized access.</p>
      </section>
      <section>
        <h2>Acceptable use</h2>
        <p>You agree not to use the Service to create, edit, or share content that is unlawful, infringes another person's rights, or violates applicable law. You also agree not to attempt to disrupt, reverse engineer, or gain unauthorized access to the Service.</p>
      </section>
      <section>
        <h2>Your content</h2>
        <p>You retain ownership of the photos, videos, audio, and projects you create with KinetoCut. You are solely responsible for ensuring you have the necessary rights and permissions for any media you import or edit. Because KinetoCut never uploads your source media to our servers, we do not access, host, or claim any rights in your original files.</p>
      </section>
      <section>
        <h2>Intellectual property</h2>
        <p>The KinetoCut name, logo, app, and website design are owned by us or our licensors and are protected by intellectual property law. These Terms do not grant you any right to use our branding except as needed to use the Service.</p>
      </section>
      <section>
        <h2>Service availability</h2>
        <p>We aim to keep KinetoCut reliable, but we do not guarantee the Service will always be available, uninterrupted, or error-free. Features may be added, changed, or removed as the product evolves.</p>
      </section>
      <section>
        <h2>Termination</h2>
        <p>You may stop using KinetoCut and request account deletion at any time by contacting <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>. We may suspend or terminate accounts that violate these Terms.</p>
      </section>
      <section>
        <h2>Disclaimer and limitation of liability</h2>
        <p>The Service is provided "as is" without warranties of any kind, to the extent permitted by law. To the fullest extent permitted by applicable law, we are not liable for indirect, incidental, or consequential damages arising from your use of the Service.</p>
      </section>
      <section>
        <h2>Changes to these terms</h2>
        <p>We may update these Terms from time to time. Material changes will be reflected by updating the effective date above. Continued use of the Service after a change means you accept the updated Terms.</p>
      </section>
      <section>
        <h2>Contact us</h2>
        <p>Questions about these Terms can be sent to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </section>
    </InfoPage>
  );
}
